import React, { useContext, useEffect, useState } from "react";
import "../../components/optimization-output-report/OptimizationOutputReport.css";
import { ReportContext } from "../../layout/Content/MainContent.component";
import Button from "@material-ui/core/Button";
import { green } from "@material-ui/core/colors";
import SingleSelect from "../common/dropdown/SingleSelect.component";
import axios from "axios";
import OptimizationReportTable from "./optimizationReportTable"
import { fetch_optimization_report } from "../../config/apiUrls";
import ClipLoader from "react-spinners/ClipLoader";

import {
  createMuiTheme,
  makeStyles,
  withStyles,
  ThemeProvider
} from "@material-ui/core/styles";

const useStyles = makeStyles({
  table: {
    minWidth: 700
  },
  name: {
    fontFamily: "OpenSans",
    fontWeight: 600
  },
  divider: {
    borderLeft: "1px solid",
    margin: "3px 7px",
    height: 15
  },
  text: {
    fontFamily: "OpenSans",
    fontSize: "0.75rem",
    color: "#999",
    alignItems: "center"
  },
  textBold: {
    marginLeft: 3,
    fontWeight: 600
  }
});
const theme = createMuiTheme({
  palette: {
    primary: green
  }
});

function OptimizationOutputReport(props) {
  const classes = useStyles();

  const { reportId, navigateToOptimizationReportStatus } = useContext(ReportContext);
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ data: "uplift", label: "Uplift" });
  const [metrics, setMetrics] = React.useState({})

  const handleMetricSelection = (data, index) => {
    let met = { ...metrics }
    met["metric_" + index] = data;
    setMetrics(met);
  }


  useEffect(() => {
    setLoading(true);
    setReportData(null);
    axios.post(fetch_optimization_report, { reportId: reportId }).then(response => {//1398
      let temp = {}
      response.data.mediumMetric.forEach(item => {
        let index = response.data.mediums.indexOf(item.medium);
        if (index > -1) {
          if (item.metric === "grp") {
            temp["metric_" + index] = { data: "grps", label: "GRPs" }
          }
          else if (item.metric === "impression") {
            temp["metric_" + index] = { data: "impressions", label: "Impressions" }
          }
          else if (item.metric === "spend") {
            temp["metric_" + index] = { data: "spend", label: "Spend" }
          }
        }
      })
      setMetrics(temp)
      setReportData(response.data);
      setLoading(false);
    })
  }, [])

  return (
    <div style={{ margin: "0px 5rem" }}>
      <div
        style={{
          display: "flex",
          height: 52,
          alignItems: "center",
          padding: "5px 20px",
          marginBottom: 10,
          fontFamily: "OpenSans"
        }}
      >
        <div className={classes.name}>Optimization Report</div>
        <div
          className={classes.text}
          style={{
            display: "flex",
            marginLeft: 50,
            alignItems: "flex-end",
          }}
        >
          {/* <div style={{ fontSize: "0.7rem", fontWeight: 600, marginBottom: 5, color: "#000" }}>Viewing Minutes/Uplift</div> */}
          <SingleSelect
            items={[{ data: "viewingMinutes", label: "Viewing Minutes" }, { data: "uplift", label: "Uplift" },]}
            defaultValue={filter}
            onChange={setFilter}
            labelKey={"label"}
            styles={{ maxWidth: 150 }}
          />
        </div>
        <div style={{ marginLeft: "auto", fontSize: "0.85rem" }}>
          - Viewing Minutes represents (000s)<br />
          - Spend represents $(000s)<br />
          - Impressions represents (000s)
</div>
      </div>
      {reportData && reportData.networks.length > 0 && reportData.networks.map((network, index) => (
        <React.Fragment key={index}>
          <OptimizationReportTable metrics={metrics} handleMetricSelection={handleMetricSelection} index={index} filter={filter.data} headers={reportData.mediums} data={network} />
        </React.Fragment>
      ))}
      {reportData && reportData.networks.length === 0 &&
        <div style={{ padding: 10 }}>No data found</div>
      }
      {loading && <center>
        <ClipLoader
          color={"#1976d2"}
          align="center"
          loading={loading}
          size={100}
        />
      </center>}
      <Button
        variant="outlined"
        style={{ marginTop: "10px", marginRight: "10px", float: "right" }}
        // classes={{ root: classes.button, label: classes.buttonLabel }}
        onClick={e => { setReportData(null); navigateToOptimizationReportStatus() }}
      >
        Close
      </Button>
    </div>
  );
}

export default OptimizationOutputReport;
